import Link from 'next/link';
import { Logo } from '../logo';

interface LogoWithLinkProps {
  className?: string;
}

export const LogoWithLink = ({ className }: LogoWithLinkProps) => {
  return (
    <Link href="/">
      <Logo className={className} />
    </Link>
  );
};
